import {API} from 'aws-amplify';
import axios from 'axios';

import {fileToArrayBuffer} from '../helpers/fileHelpers';
import {ENDPOINT} from '../constants';

// Upload file to S3 via pre-signed URL
export async function uploadFileToS3(uploadType, file, mimeType, progressCallback) {
  const request = {
    body: {
      uploadType,
      mimeType,
    },
  };
  const {signedURL, objectURL} = await API.post(ENDPOINT, `/files/signed-url`, request);
  const dataArrayBuffer = await fileToArrayBuffer(file);
  const options = {
    headers: {
      'Content-Type': mimeType,
    },
    onUploadProgress: (progressEvent) => {
      if (progressCallback) progressCallback((progressEvent.loaded / progressEvent.total) * 100);
    },
  };

  await axios.put(signedURL, dataArrayBuffer, options);
  return objectURL;
}
